import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { Layout } from '../../components/layout';
import { RightSidebar, View } from './components';
import './Regulation.styles.css';
import { RegulationsActionsBar } from './components/regulations-actions-bar';
import { LeftSidebar } from '../dashboard/components';
import { useRegulation } from './useRegulation';

export default function DraftRegulation() {
  const { id, data } = useRegulation();
  const navigate = useNavigate();
  const location = useLocation();
  const queryClient = useQueryClient();

  // The BE resolves old ids to the latest published version; keep the URL id equal to the displayed id.
  useEffect(() => {
    if (!data?.id || String(data.id) === id) return;
    // The redirect drops `?history=true`, so the target query key uses history = false.
    queryClient.setQueryData(['draftRegulation', String(data.id), false], data);
    navigate(location.pathname.replace(`/regulation/${id}`, `/regulation/${data.id}`), {
      replace: true,
    });
  }, [data, id, location.pathname, navigate, queryClient]);

  return (
    <Layout leftSidebar={<LeftSidebar />} rightSidebar={<RightSidebar />}>
      <div className="draft-regulation-container">
        <RegulationsActionsBar />
        <View />
      </div>
    </Layout>
  );
}
